interface ProgressRailProps {
  total: number;
  /** 1-based index of the question currently on screen. */
  current: number;
}
export function ProgressRail({
  total,
  current
}: ProgressRailProps) {
  return <div className="flex items-center gap-1.5" role="progressbar" aria-valuemin={1} aria-valuemax={total} aria-valuenow={current} aria-label={`Pergunta ${current} de ${total}`} data-id="element-51" data-mp="1ywo8a4kela0x">
      {Array.from({
      length: total
    }, (_, i) => <span key={i} className={`h-[2px] w-8 transition-colors duration-300 ease-soft ${i < current ? 'bg-cream-100' : 'bg-cream-100/25'}`} data-id="element-52" data-mp="1p4i7q6g35ka4" />)}
      <span className="ml-3 font-sans text-[11px] uppercase tracking-widest2 text-cream-100/60" data-id="element-53" data-mp="1f6kjvk251pi1">
        {String(current).padStart(2, '0')} / {String(total).padStart(2, '0')}
      </span>
    </div>;
}